import { BoxProps, StackProps } from '@chakra-ui/react';

import { ICardStyles } from 'components/DataDisplay/Card/Card';

export const clearFormTextStyle: any = {
  size: 'xs',
  textAlign: 'right',
  color: 'primary',
  cursor: 'pointer',
};

export const searchQueryTermStyle = {
  _hover: { bg: 'gray.50' },
  py: 2,
  align: 'flex-start',
  cursor: 'pointer',
};

export const detailsCardStyles: ICardStyles = {
  card: {
    w: 'full',
    h: 'full',
    overflow: 'auto',
    pt: 0,
  },
  header: {
    pb: 0,
  },
};

export const alertsCardStyles: ICardStyles = {
  card: { w: 'full', h: 48, overflow: 'auto' },
  header: { pb: 0 },
};

export const detailsContentStyles: StackProps = {
  spacing: 2,
  w: 'full',
  h: 'full',
  fontSize: '2xs',
  maxW: '400px',
};

export const searchNodeStyles: BoxProps = {
  right: 0,
  pos: 'absolute',
  bottom: 'calc(100% + 4px)',
};

export const mapHeader = 16;
export const PAGE_HEIGHT = window.innerHeight - 190 + 'px';
export const MAP_HEIGHT = window.innerHeight - 190;
